var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNonVeg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 2.66671V13.3334H2.66671V2.66671H13.3334ZM14.6667 1.33337H1.33337V14.6667H14.6667V1.33337ZM8.00004 4.00004C5.79337 4.00004 4.00004 5.79337 4.00004 8.00004C4.00004 10.2067 5.79337 12 8.00004 12C10.2067 12 12 10.2067 12 8.00004C12 5.79337 10.2067 4.00004 8.00004 4.00004Z",
    fill: "#EF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonVeg);
export default __webpack_public_path__ + "static/media/nonVeg.546415bca9635e54b5facebbc6e8d4ee.svg";
export { ForwardRef as ReactComponent };